module.exports = __webpack_public_path__ + "static/media/portfolio (18).aa4bc7d0.jpg";